import React from 'react';
const Loader = (props) => {
  const imgSrc = props?.imageColor == "white" ? `/assets/images/spinner-white.svg` : `/assets/images/spinner.svg`
    return (
      <div className={`fixed-loader-area${props?.className ? ` ${props?.className}`: ''}`}>
        <img
          className="loader-img"
          src={imgSrc}
          alt="loader"
        />
        {props?.text && <p className="loader-text">{props.text}</p>}
      </div>
    );
}

export default Loader;
